// extracted by mini-css-extract-plugin
export default {"scrollButton":"ScrollToTopButton_scrollButton__ozyuK","visible":"ScrollToTopButton_visible__rfeq5"};